var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// This file contains our base typography styles to be applied directly to their corresponding elements
export var h1Sx = {
    fontFamily: 'heading',
    fontWeight: 8,
    fontSize: [4, 5],
    lineHeight: [1.17, 1.39],
};
export var h2Sx = {
    fontFamily: 'heading',
    fontWeight: 3,
    fontSize: 4,
    lineHeight: 'normal',
};
export var h3Sx = {
    fontFamily: 'heading',
    fontWeight: 3,
    fontSize: 3,
    lineHeight: 'normal',
};
export var h4Sx = {
    fontFamily: 'heading',
    fontWeight: 3,
    fontSize: '1.125rem',
    lineHeight: 'normal',
};
export var bodyTextSx = {
    fontFamily: 'body',
    fontWeight: 3,
    fontSize: 2,
    margin: 0,
};
export var bodyLargeTextSx = {
    fontFamily: 'body',
    fontWeight: 3,
    fontSize: 2,
    lineHeight: 'normal',
};
export var bodyMediumTextSx = {
    fontFamily: 'body',
    fontWeight: 3,
    fontSize: 1,
    lineHeight: 'normal',
};
export var labelSmallTextSx = {
    fontFamily: 'body',
    fontWeight: 5,
    fontSize: 0,
    lineHeight: 'normal',
};
export var labelMediumTextSx = {
    fontFamily: 'body',
    fontWeight: 5,
    fontSize: 1,
    lineHeight: 'normal',
};
export var labelLargeTextSx = {
    fontFamily: 'body',
    fontWeight: 5,
    fontSize: 2,
    lineHeight: 'normal',
};
export var labelExtraLargeTextSx = {
    fontFamily: 'body',
    fontWeight: 5,
    fontSize: '1.125rem',
    lineHeight: 'normal',
};
export var textSx = __assign(__assign({}, bodyTextSx), { lineHeight: 1.43 });
export var formControlSmallSx = {
    fontFamily: 'body',
    fontSize: 0,
    fontWeight: 3,
    lineHeight: 'normal',
};
